import dayjs from 'dayjs'

/**
 * 受注日時の表示。
 *
 * API はオフセット付き ISO8601 を返す（列は UTC 保持）。**閲覧者のローカルTZで表示する**
 * ため特定TZへ固定しない（.claude/rules/timezone-frontend.md）。
 * 生の文字列をそのまま描画すると、オフセットが読まれずローカル時刻と解釈されて
 * 9時間ずれる。
 */
export const orderDatetimeText = (value: string | null | undefined): string =>
  value ? dayjs(value).format('YYYY/MM/DD HH:mm:ss') : '—'
